import React from 'react'
import styles from './styles/login.module.scss'
import HeaderBack from "../components/HeaderBack"
import Layout from "../components/Layout"
import {navigate} from 'gatsby'
import SEO from "../components/seo"
import {useSelector} from 'react-redux'
import LoginCard from '../components/LoginCard'
import './styles/lottie.css'
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';


const useStyles = makeStyles(theme => ({
	root: {
	  flexGrow: 1,
	},
	paper: {
	  padding: theme.spacing(2),
	  textAlign: 'center',
	  color: theme.palette.text.secondary,
	},
  }));

const Login = () => {
	const isLogged = useSelector(state => state.user.isLogged)
	const classes = useStyles();

	if(isLogged){
		navigate('/')
	}
	return(
		<Layout>
			<SEO title="Login" />
			<HeaderBack
				title="Ingresar"
				description="Ingresa con tu cuenta cowork entre todos,si no tienes una puedes Unirte ¡Es grátis!"
				image={require('./../images/ingresar.jpg')}
			/>
			<div className={classes.root}>
				<Grid container spacing={3}
				style = {{
					justifyContent: "center",
					display: "flex",
					marginTop: "1rem"
				}}>
					<Grid item xs={11} md = {5}>
						<LoginCard/>
					</Grid>
				</Grid>
			</div>
			{/* <div className={styles.loginContainer}>
				<LoginCard/>
			</div> */}
		</Layout>
	)
}

export default Login
